<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <RootLayout />
    </transition>
    <base-notification group="auth" class="auth" />
    <base-notification group="app" class="app" />
    <div
      v-if="serviceWorkerUpdated"
      id="service-worker-update-notification"
      class="bg-primary-dark text-white p-5"
    >
      {{ newVersionText }}!
      <span class="font-bold cursor-pointer" @click="onAppReload">{{ reloadText }}</span>
    </div>
  </div>
</template>

<script>
import LoadingLayout from '@/components/layouts/LoadingLayout.vue'
import {BaseNotification} from '@/components/base'
import {serviceWorkerUpdate} from '@/state/helpers/mixins'

export default {
  components: {
    BaseNotification,
    LoadingLayout,
    RootLayout: () => ({
      // The component to load (should be a Promise)
      component: import(/* webpackChunkName: "rootLayout" */ '@/components/layouts/RootLayout.vue'),
      // A component to use while the async component is loading
      loading: LoadingLayout,
      // A component to use if the load fails
      error: import(/* webpackChunkName: "errorLayout" */ '@/components/layouts/ErrorLayout.vue'),
      // Delay before showing the loading component. Default: 200ms.
      delay: 10,
      // The error component will be displayed if a timeout is
      // provided and exceeded. Default: Infinity.
      timeout: 10000,
    }),
  },

  computed: {
    newVersionText() {
      return this.$t('mygwf.app.new_version')
    },
    reloadText() {
      return this.$t('mygwf.app.reload')
    },
  },

  mixins: [serviceWorkerUpdate],
}
</script>

<style>
#service-worker-update-notification {
  position: fixed;
  right: 1%;
  bottom: 1%;
  z-index: 9999;
}
</style>
